// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography() {
	return {
		MuiTypography: {
			styleOverrides: {
				gutterBottom: {
					marginBottom: 12,
				},
				h6: {
					fontWeight: "bold",
					textTransform: "uppercase",
					fontSize: 12,
					color: "#3C4856",
				},
			},
		},
	};
}
